<script>
import EmployeeAPI from "@/services/employee/employeeAPI";
import CopassConformationActAPI from "@/services/standards/copassConformationActAPI";
import CheckModal from "@/components/CheckModal";
import Swal from "sweetalert2";
import { dateFormat } from "@/utils/helpers/format";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "@/services/newScores/newScoresAPI";
import ItemAPI from "@/services/items/itemsAPI";
import DontExist from "@/components/company/components/DontExist";
import DocumentActions from "@/components/document/DocumentActions.vue";

export default {
  props: {
    companyID: { type: Number, default: 0 },
  },
  components: { CheckModal, DontExist, DocumentActions },
  data() {
    return {
      employees: [],
      nit: this.$store.getters["company/getCompany"].nit || null,
      copasstID: this.$route.params.copasst,
      employee: null,
      copassDate: null,
      vigenciaDesde: null,
      vigenciaHasta: null,
      workflowStatus: "draft",
      signedAt: null,
      item: null,
      itemData: null,
      submitted: false,
      loading2: true,
    };
  },
  computed: {
    isSigned() {
      return this.workflowStatus === "signed";
    },
    vigiaApi() {
      return {
        pdfUrl: (id) => CopassConformationActAPI.pdfUrl(id),
        sign: (id, payload) => CopassConformationActAPI.sign(id, payload),
      };
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(6).then((r) => (this.itemData = r)).catch((e) => console.log(e));
    },
    goBack() {
      this.$router.go(-1);
    },
    allowAccess() {
      try {
        const item = this.itemData;
        const c = this.$store.getters["company/getCompany"].company_classification_id || null;
        if (!item) return false;
        if (c === 1 && item.obligatory_UPA === 1) return true;
        if (c === 2 && item.obligatory_groupI === 1) return true;
        if (c === 3 && item.obligatory_groupII === 1) return true;
        if (c === 4 && item.obligatory_groupIII === 1) return true;
        return false;
      } catch (e) {
        return false;
      }
    },
    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 6).then((r) => (this.item = r || null)).catch((e) => console.log(e));
    },
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },
    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (!role) return false;
      if (roles) role = roles.includes(role);
      else role = [1, 2, 3, 4, 5, 6, 7, 8].includes(role);
      const enabled = this.$store.state.auth.info.permissions.find((p) => p.name === name);
      return enabled && role ? true : false;
    },
    dateConvert(date) {
      return dateFormat(date);
    },
    getEmployees() {
      EmployeeAPI.getAll(this.companyID)
        .then((response) => {
          const all = response.employee || [];
          this.employees = all.filter(
            (e) => (e.contract_type_id === 1 || e.contract_type_id === 3) && e.is_active === 1
          );
        })
        .catch((e) => console.log(e));
    },
    getConformationActs() {
      CopassConformationActAPI.get(this.copasstID)
        .then((response) => {
          if (!response) return;
          this.employee = response.employee_id;
          this.copassDate = response.date ? String(response.date).substring(0, 10) : null;
          this.vigenciaDesde = response.vigencia_desde ? String(response.vigencia_desde).substring(0, 10) : null;
          this.vigenciaHasta = response.vigencia_hasta ? String(response.vigencia_hasta).substring(0, 10) : null;
          this.workflowStatus = response.workflow_status || "draft";
          this.signedAt = response.signed_at || null;
          this.loading2 = false;
        })
        .catch((e) => console.log("error getConformationActs", e));
    },
    save() {
      if (this.isSigned) return;
      this.submitted = true;
      CopassConformationActAPI.update(this.copasstID, {
        date: this.copassDate,
        position: "Vigía de salud",
        employee_id: this.employee,
        vigencia_desde: this.vigenciaDesde,
        vigencia_hasta: this.vigenciaHasta,
      })
        .then(() => {
          newScoresAPI
            .calculateScores({ companies_id: this.companyID, item_id: 6, status: "Pendiente" })
            .then(() => {
              this.submitted = false;
              Swal.fire({ title: "¡Éxito!", text: "¡Se ha actualizado con éxito!", icon: "success", confirmButtonClass: "btn btn-confirm mt-2" });
            })
            .catch(() => (this.submitted = false));
        })
        .catch((e) => {
          console.log(e);
          this.submitted = false;
          Swal.fire("Error", "No se pudo actualizar", "error");
        });
    },
    onSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },
  },
  mounted() {
    this.getEmployees();
    this.getConformationActs();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-9">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <CheckModal>
                <p class="text-justify">
                  <b>Vigía en Seguridad y Salud en el Trabajo</b> para empresas de menos de diez (10) trabajadores.
                  Digita los datos del designado y la vigencia; la plataforma genera el acta para firma del representante legal.
                </p>
              </CheckModal>
            </div>
          </div>
          <h5 class="pt-2">Designado del Empleador (Vigía SST)</h5>

          <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
            🔒 Esta acta ya fue firmada; los datos quedan bloqueados para edición.
          </div>

          <form class="form-group" @submit.prevent="save">
            <div class="form-row pt-3">
              <b-form-group class="col-md-6 px-2" label="Nombre del Vigía" label-for="nameEmployee">
                <b-form-select :disabled="isSigned || !allowAccess() || !getRole('Crear')" required class="form-control" v-model="employee">
                  <b-form-select-option v-for="emp in employees" :key="emp.id" :value="emp.id">
                    {{ emp.full_name }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>

              <b-form-group class="col-md-6 px-2" label="Fecha de designación" label-for="date">
                <b-form-input :disabled="isSigned || !allowAccess() || !getRole('Crear')" required type="date" id="date" v-model="copassDate"></b-form-input>
              </b-form-group>

              <b-form-group class="col-md-6 px-2" label="Vigencia desde" label-for="vigDesde">
                <b-form-input :disabled="isSigned" type="date" id="vigDesde" v-model="vigenciaDesde"></b-form-input>
              </b-form-group>

              <b-form-group class="col-md-6 px-2" label="Vigencia hasta" label-for="vigHasta">
                <b-form-input :disabled="isSigned" type="date" id="vigHasta" v-model="vigenciaHasta"></b-form-input>
              </b-form-group>
            </div>

            <div class="form-group text-right mr-2">
              <button :disabled="isSigned || !allowAccess() || !getRole('Crear')" type="submit" class="btn btn-primary mx-1">Guardar</button>
              <button type="button" class="btn btn-secondary mx-1" @click="goBack()">Cancelar</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="col-md-3" v-if="copasstID && companyID">
      <h6 class="text-muted small mb-1">Acta de Asignación de Vigía</h6>
      <DocumentActions
        :document-id="Number(copasstID)"
        :company-id="companyID"
        :workflow-status="workflowStatus"
        :signed-at="signedAt"
        :api-service="vigiaApi"
        document-title="Acta de Asignación de Vigía SST"
        signer-role="gerente"
        @signed="onSigned"
      />
    </div>
  </div>
</template>
